import React, { forwardRef } from 'react'
import { FieldTypes } from 'utils/formUtils';
import TraceableMappingFormV2 from './TraceableMappingFormV2'
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';

const DEFAULT_CONFIG_DAYS = 10;

function TraceableCredentialForm(props, ref) {

    const fields = [
    {
        name: "apiEndpoint",
        label: "API Endpoint",
        required: false
    },
    {
        name: "token",
        label: "API Token",
        required: true,
        type: FieldTypes.PASSWORD,
    },
    {
        name: "days",
        label: "Days",
        type: FieldTypes.NUMBER,
        min: 1
    }
];

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={TraceableMappingFormV2}
            initialValue={{ apiEndpoint: "https://api.traceable.ai", days: DEFAULT_CONFIG_DAYS }}
        />
    )
}

export default forwardRef(TraceableCredentialForm);